// extracted by mini-css-extract-plugin
module.exports = {"countdownTimer":"CountdownTimer_countdownTimer__2P2IZ","timeContainer":"CountdownTimer_timeContainer__nQYyl","timeLeft":"CountdownTimer_timeLeft__1MIoh"};